import { render } from "./BaseTermCheckbox.vue?vue&type=template&id=bfe6866c&scoped=true"
import script from "./BaseTermCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseTermCheckbox.vue?vue&type=script&lang=js"

import "./BaseTermCheckbox.vue?vue&type=style&index=0&id=bfe6866c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe6866c"]])

export default __exports__